import { ExtendedColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { PersonFilterWithSearch } from './PersonFilterWithSearch';
import { DocumentWorkflowInstanceSignatureStatus } from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const NO_SIGNATURE_REQUIRED_FILTER_VALUE = 'NO_SIGNATURE_REQUIRED';

interface Props<TData, TValue> {
	column: ExtendedColumn<TData, TValue>;
	filterText?: string;
}

export const InvestorFilter = <TData, TValue>({ column, filterText }: Props<TData, TValue>) => {
	const tMipManage = useTranslationMipManage();
	const sections = [
		{
			title: tMipManage('documents_page.investor_filter.section_title'),
			fieldKey: 'signatureStatuses',
			options: [
				{
					value: DocumentWorkflowInstanceSignatureStatus.CREATED,
					label: tMipManage('documents_page.signature_status.pending'),
				},
				{
					value: DocumentWorkflowInstanceSignatureStatus.SIGNED,
					label: tMipManage('documents_page.signature_status.signed'),
				},
				{
					value: NO_SIGNATURE_REQUIRED_FILTER_VALUE,
					label: tMipManage('documents_page.signature_status.no_signature_required'),
				},
				{
					value: DocumentWorkflowInstanceSignatureStatus.DECLINED,
					label: tMipManage('documents_page.signature_status.declined'),
				},
				{
					value: DocumentWorkflowInstanceSignatureStatus.EXPIRED,
					label: tMipManage('documents_page.signature_status.expired'),
				},
				{
					value: DocumentWorkflowInstanceSignatureStatus.ERROR,
					label: tMipManage('documents_page.signature_status.error'),
				},
			],
		},
	];

	return (
		<PersonFilterWithSearch
			column={column}
			filterText={filterText}
			nameFieldKey="investorName"
			sections={sections}
		/>
	);
};
